import React, { useEffect, useState } from "react";
import { Badge, Card, Col, Form, Row, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import axiosInstance from "../services/axiosInterceptor";
import { useLoading } from "../contexts/LoadingContext";
import Header from "../layouts/Header";

const DAY_NAMES = ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัสบดี", "ศุกร์", "เสาร์"];

export default function MyClubs() {
  const { setLoading } = useLoading();
  const [years, setYears] = useState([]);
  const [yearId, setYearId] = useState("");
  const [clubs, setClubs] = useState([]);

  useEffect(() => {
    axiosInstance.get("/api/clubs/references").then(({ data }) => {
      setYears(data.years);
      const selected = data.years.find(y => String(y.year_id) === localStorage.getItem("yearId")) || data.years[0];
      if (selected) setYearId(String(selected.year_id));
    });
  }, []);

  useEffect(() => {
    if (!yearId) return;
    setLoading(true);
    axiosInstance.get("/api/clubs/my-clubs", { params: { year_id: yearId } })
      .then(({ data }) => setClubs(data))
      .catch(() => Swal.fire("ผิดพลาด", "โหลดข้อมูลชุมนุมไม่สำเร็จ", "error"))
      .finally(() => setLoading(false));
  }, [yearId, setLoading]);

  return (
    <>
      <Header />
      <main className="main main-app p-3 p-lg-4">
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-4">
        <div><h4 className="main-title mb-1">ชุมนุมของฉัน</h4><div className="text-secondary">เช็คชื่อและประเมินผลสมาชิกชุมนุม</div></div>
        <Form.Select value={yearId} onChange={e => setYearId(e.target.value)} style={{ width: 190 }}>
          {years.map(y => <option key={y.year_id} value={y.year_id}>ปีการศึกษา {y.year_year}</option>)}
        </Form.Select>
      </div>
      <Row className="g-3 mb-4">
        <Col sm={6} lg={3}><Summary label="ชุมนุมที่ดูแล" value={clubs.length} /></Col>
        <Col sm={6} lg={3}><Summary label="สมาชิกทั้งหมด" value={clubs.reduce((n, c) => n + Number(c.enrolled || 0), 0)} /></Col>
        <Col sm={6} lg={3}><Summary label="ผลภาค 1 ค้าง" value={clubs.reduce((n, c) => n + Number(c.sem1_pending || 0), 0)} /></Col>
        <Col sm={6} lg={3}><Summary label="ผลภาค 2 ค้าง" value={clubs.reduce((n, c) => n + Number(c.sem2_pending || 0), 0)} /></Col>
      </Row>
      <Card className="card-one">
        <Card.Header><Card.Title as="h6" className="mb-0">รายการชุมนุม</Card.Title></Card.Header>
        <Card.Body className="p-0">
          <Table responsive hover className="mb-0 align-middle">
            <thead><tr><th>ชุมนุม</th><th>หน้าที่</th><th>สมาชิก</th><th>ตาราง</th><th>เช็คล่าสุด</th><th /></tr></thead>
            <tbody>
              {clubs.map(club => (
                <tr key={club.club_year_id}>
                  <td><div className="fw-semibold">{club.club_name}</div><Badge bg={club.club_gender === "m" ? "primary" : "danger"}>{club.club_gender === "m" ? "ชาย" : "หญิง"}</Badge></td>
                  <td>{club.advisor_role === "lead" ? "ครูหลัก" : "ครูผู้ช่วย"}</td>
                  <td>{club.enrolled}/{club.club_quota}</td>
                  <td>
                    <div>ภาค 1: {club.sem1_day == null ? "-" : `วัน${DAY_NAMES[club.sem1_day]} คาบ ${club.sem1_period}`}</div>
                    <div>ภาค 2: {club.sem2_day == null ? "-" : `วัน${DAY_NAMES[club.sem2_day]} คาบ ${club.sem2_period}`}</div>
                  </td>
                  <td>{club.last_session_date ? String(club.last_session_date).slice(0, 10) : "-"}</td>
                  <td className="text-end"><Link className="btn btn-sm btn-primary" to={`/clubs/my/${club.club_year_id}`}>เปิดชุมนุม</Link></td>
                </tr>
              ))}
              {!clubs.length && <tr><td colSpan="6" className="text-center py-5 text-secondary">ยังไม่ได้รับมอบหมายให้ดูแลชุมนุมในปีนี้</td></tr>}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
      </main>
    </>
  );
}

function Summary({ label, value }) {
  return <Card className="card-one h-100"><Card.Body><div className="fs-3 fw-semibold text-primary">{value}</div><div className="text-secondary">{label}</div></Card.Body></Card>;
}

